import { render, staticRenderFns } from "./Estudantes-fora-epoca-kilamba.vue?vue&type=template&id=4f8ecfdd&scoped=true&"
import script from "./Estudantes-fora-epoca-kilamba.vue?vue&type=script&lang=js&"
export * from "./Estudantes-fora-epoca-kilamba.vue?vue&type=script&lang=js&"
import style0 from "./Estudantes-fora-epoca-kilamba.vue?vue&type=style&index=0&id=4f8ecfdd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8ecfdd",
  null
  
)

export default component.exports